/**
 * mixins混入
 * suliyu
 * 2017年07月04日09:16:40
 */

import filters from './filters'
import computed from "./computed"
import methods from './methods'

export default {
  data: function () {
    return {
      openShopifyLink: true,
      timeZone: "UTC+8",
      
    }
  },
  filters,
  computed,
  methods

}
